<template>
  <div>
    Redirecting...
  </div>
</template>

<script>
import auth from '@/auth'
import jwt from 'jwt-simple'
import uuid from 'uuid'
import url from 'url'

export default {
  data () {
    return {
      secretKey: 'vMONa2sf2DhQ1SJ0RrEyQx9PbOen7nmUYAvnPvj0jwscKHH0',
      subdomain: 'smartrtb'
    }
  },
  created () {
    if (auth.isAuthenticated()) {
      this.redirectToZendesk()
    } else {
      this.redirectToLogin()
    }
  },
  methods: {
    redirectToLogin () {
      this.$router.push({ 
        name: 'Login', 
        query: { next: this.$router.currentRoute.path } 
      })
    },
    redirectToZendesk () {
      let payload = {
        iat: (new Date().getTime() / 1000),
        jti: uuid.v4(),
        email: auth.details().email,
        name: auth.details().name
      }

      let token = jwt.encode(payload, this.secretKey)
      let redirect = 'https://' + this.subdomain + '.zendesk.com/access/jwt?jwt=' + token
      
      window.location.replace(redirect)

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/support/pages/ZendeskRedirect.vue